/* global $ jQuery */
$(function () {
  const target = parent.postMessage
    ? parent
    : parent.document.postMessage
      ? parent.document
      : undefined;

  jQuery.postMessage(
    {
      url: window.location.href,
      height: document.body.clientHeight,
    },
    '*',
    target
  );

  /* Redirect booking form submit to our side */
  $('form#new_booking').on('submit', function (evt) {
    evt.preventDefault();
    evt.stopImmediatePropagation();

    if ($('input.date-input').val() == '') {
      alert('Please select a date for your booking.');
      return;
    }

    jQuery.postMessage(
      {
        url: window.location.href,
        booking: true,
        form_params: $('form#new_booking').serializeArray(),
      },
      '*',
      target
    );
    return false;
  });

  /* Links that need to point to external */
  $('#logo a, .guide-image a, .right a.more-info, .guide-bio p a').click(
    function (evt) {
      top.location = evt.currentTarget.href;
    }
  );

  /* Client height change watchdog */
  let oldClientHeight = document.body.clientHeight;
  const checkHeightChange = function () {
    if (oldClientHeight != document.body.clientHeight) {
      jQuery.postMessage(
        {
          url: window.location.href,
          height: document.body.clientHeight,
        },
        '*',
        target
      );
      oldClientHeight = document.body.clientHeight;
    }
  };
  setInterval(checkHeightChange, 200);

  // It's late, I'm sleepy
  $(function () {
    setTimeout(function () {
      $('img').trigger('unveil');
    }, 2000);
  });
});
